import { SummaryCard } from "./withdrawalUtils";

const WithdrawalSummaryCards = ({ stats }) => (
  <div className="flex flex-wrap gap-3 mb-5">
    <SummaryCard label="Total Requests" value={stats.total} color="#1e293b" />
    <SummaryCard label="Pending Withdrawals" value={stats.pending} color="#d97706" />
    <SummaryCard label="Approved" value={stats.approved} color="#16a34a" />
    <SummaryCard label="Completed" value={stats.paid} color="#059669" />
    <SummaryCard label="Rejected" value={stats.rejected} color="#dc2626" />
    <SummaryCard
      label="Total Pending Amount"
      value={`₦${stats.totalPendingAmount.toLocaleString()}`}
      color="#d97706"
    />
    <SummaryCard label="Total Completed" value={`₦${stats.totalPaid.toLocaleString()}`} color="#059669" />
  </div>
);

export default WithdrawalSummaryCards;